/**
 * @author Andrew Gower <amogower@gmail.com>
 */

import HTTP from '../HTTP';

import { StringHelper } from '../../helpers';

/**
 * APIRequest Class
 * @constructor
 * @param {Object} config - The store config object
 * @param {Object} type - The type of data
 * @param {Object} data - The data object
 * @param {Object} relationships - The relationships data object
 */

export default class APIRequest extends HTTP {
    constructor(store, type, dataObj) {
        if (!store) {
            throw new Error('APIRequest->constructor: config - ', store);
        }
        super(store);
        if (dataObj) {
            this.body = this.mungeRequestObject(type, dataObj);
        }
    }

    /**
     * Method for creating JSON API spec APIRequest object
     * @param {Object} type - The data resource type
     * @param {Object} dataObj - The data object
     * @return {Object} APIRequest object
     */
    mungeRequestObject(type, dataObj) {
        if (!dataObj) {
            throw new Error('APIRequest->mungeRequestObject: dataObj - ', dataObj);
        }
        const requestObj = {
            data: {
                type,
                attributes: {
                    ...dataObj.data
                }
            }
        };
        if (dataObj.data && dataObj.data.id) {
            requestObj.data.id = dataObj.data.id;
        }
        if (dataObj.relationships) {
            requestObj.data.relationships = {};
            Object.keys(dataObj.relationships).forEach(relation => {
                const string = new StringHelper(relation);
                const relationType = `${string.toSnakeCase()}s`;
                requestObj.data.relationships[relation] = {
                    data: {
                        id: dataObj.relationships[relation].id,
                        type: relationType
                    }
                };
            });
        }
        if (dataObj.meta) {
            requestObj.meta = dataObj.meta;
        }
        return requestObj;
    }
}



// WEBPACK FOOTER //
// ./src/API/APIRequest/APIRequest.js